import { Grid, Filter, Page, Sort, RecordClickEventArgs, Toolbar } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { AddOrUpdateDocumentationTopicManager, AddOrUpdateSoftwareVersionManager } from '../../Exporters/ManagersExporter';
import { ConfirmModal } from '../../Helpers/ConfirmModal';

export class WebScraperPortalTemplateManager {

    constructor(private containerElement: JQuery) { }
    
    private addOrUpdatePortalTemplateModalHelper : ModalHelper;
    private addOrUpdatePortalTemplateManager : AddOrUpdateSoftwareVersionManager;

    private pushTemplateChangesModalHelper : ModalHelper;    

    private portalTemplateGrid : Grid;


    public initialize() {
        var self = this;

        this.addOrUpdatePortalTemplateModalHelper = new ModalHelper();
        this.addOrUpdatePortalTemplateModalHelper.createModal("add-or-update-portal-template-popup", true);        
        
        this.pushTemplateChangesModalHelper = new ModalHelper();
        this.pushTemplateChangesModalHelper.createModal("push-template-changes-popup", true);

        Grid.Inject(Page, Sort, Toolbar);

        self.initializePortalTemplate();
    }

    private initializePortalTemplate() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var portalTemplateContainer = self.containerElement.find('#admin-web-scraper-portal-template-items-container');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#Grid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;


        let data: DataManager = new DataManager({
            url: '/api/admin/webscraper/portal-templates',
            adaptor: new WebApiAdaptor
        });

        self.portalTemplateGrid = new Grid(
            {
                height: '100%',
                toolbarTemplate: '#toolbar-template',
                dataSource: data,
                columns: [
                    { field: 'CreationDateTimeString', headerText: 'Creation date', width: 150},
                    { field: 'PortalName', headerText: 'Portal name'},
                    { field: 'ExtraActions', headerText: '', allowFiltering: false, allowEditing: false, autoFit: true, width: '75px', textAlign: 'Right', template: '${getAdminWebScraperExtraActions()}' }
                ],
                allowSorting: false,
                allowPaging: true,
                allowFiltering: false,
                allowSelection: false,
                pageSettings: { pageSize: 2000 },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')
                    loadingContainer.addClass('d-none');
                    portalTemplateContainer.removeClass('d-none');
                },
                recordClick: (args: RecordClickEventArgs) => {
                    if (args.target != undefined && args.rowData != undefined) {
                        var parsedTarget = $(args.target); 
                        var webScraperTemplateId = args.rowData["Id"];
    
                        if(parsedTarget.data('action') == 'push-config' || parsedTarget.parent().data('action') == 'push-config' && webScraperTemplateId != undefined) {
                            var targetButton = parsedTarget;
                            if(parsedTarget.is('i')) {
                                targetButton = parsedTarget.parent();
                            }
    
                            new ConfirmModal().initialize('Update template at client', 'Are you sure you want to start the update?</br>This will update the template at every client using this scraper.', () => {
                                targetButton.prop('disabled', true);

                                self.pushTemplateChangesModalHelper.load(`?templateId=${webScraperTemplateId}&handler=PushTemplateChanges`, undefined, () => {
                                    targetButton.prop('disabled', false);
                                }, 
                                () => {

                                });
                            }, () => {
                                targetButton.prop('disabled', false);
                            }, 'Confirm', 'Cancel')   
    
                        }
                    }
                },
                recordDoubleClick: (args: RecordClickEventArgs) => {
                    if (args.target != undefined && args.rowData != undefined) {
                        var parsedTarget = $(args.target); 
                        var portalTemplateId = args.rowData["Id"];
                        if(portalTemplateId != undefined) {
                            self.addOrUpdatePortalTemplateModalHelper.load(`?id=${portalTemplateId}&handler=AddOrUpdatePortalTemplate`, undefined, () => {

                            }, 
                            () => {
                                self.portalTemplateGrid.refresh();
                            });
                        }
                    }
                }
            });

        self.portalTemplateGrid.appendTo('#Grid');

        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var addButton = toolbar.find('#add-button');
            addButton.off('click').on('click', () => {
                self.addOrUpdatePortalTemplateModalHelper.load(`?handler=AddOrUpdatePortalTemplate`, undefined, () => {

                }, 
                () => {
                    self.portalTemplateGrid.refresh();
                });
            })

        }

        (<any>window).initializeAddOrUpdateWebScraperPortalConfig = () => {
            self.addOrUpdatePortalTemplateManager.initialize();
        }
    }

}